<template>
  <div id="app">
    <!-- <mainBox /> -->
    <router-view />
  </div>
</template>

<script>
// import mainBox from "./components/main.vue";
export default {
  name: "App",
  components: {
    // mainBox,
  },
};
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
#app {
  width: 100%;
  height: 100%;
}
@font-face {
  font-family: "fontNum";
  src: url("./assets/BNAxelGrotesk-Bold.otf");
}
.num {
  font-family: fontNum;
  letter-spacing: 3px;
}
</style>
